import { useTranslation } from 'react-i18next';

import { Tabs } from '../../components/Tabs';
import { PageHeader } from '../../components/PageHeader';
import { JobsPanel } from './JobsPanel';
import { RecurringPanel } from './RecurringPanel';
import { RulesPanel } from './RulesPanel';

/**
 * Die Automatisierung -- F3-11 bis F3-19.
 *
 * Drei Reiter auf einer Seite und nicht drei Zweige in der Navigation: Die
 * drei gehoeren zusammen und werden zusammen eingerichtet. Wer eine Regel
 * baut, schaut im selben Zug nach, ob ein Zeitplan dasselbe schon tut.
 *
 * Die Webhooks waren der vierte Reiter. Sie haben eine eigene Seite unter
 * den Schnittstellen (``WebhooksPage``): Ein Webhook ist keine Regel,
 * sondern eine Meldung nach aussen.
 *
 * **Was hier eingerichtet wird, laeuft nur, wenn der Taktgeber laeuft** --
 * ausser den Regeln, die an einem Ereignis haengen. Zeitplaene und
 * Wartungsplaene brauchen `itscrm.workers.scheduler`; deshalb steht neben
 * beiden ein Knopf, der den Lauf von Hand ausloest. Er ist zum Ausprobieren
 * da und nicht fuer den Betrieb.
 */
export function AutomationPage() {
  const { t } = useTranslation();

  return (
    <>
      <PageHeader title={t('automation.title')} subtitle={t('automation.subtitle')} />

      <Tabs
        ariaLabel={t('automation.title')}
        tabs={[
          { value: 'rules', label: t('automation.rules'), content: <RulesPanel /> },
          { value: 'jobs', label: t('automation.jobs'), content: <JobsPanel /> },
          { value: 'recurring', label: t('automation.plans'), content: <RecurringPanel /> },
        ]}
      />
    </>
  );
}
